import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingFrom";
import {validateRequired} from "../../../components/formValidation/validators";
import Stack from "@mui/material/Stack";
import CustomTextField from "../../../components/formValidation/CustomTextField";
import {useState} from "react";

const DeviceData = ({reference, data, setData}) => {
    const [errors, setErrors] = useState({
        order_rx: false,
        order_tx: false,
    });

    const validators = {
        order_rx: [validateRequired],
        order_tx: [validateRequired],
    }
    return <ErrorHandlingForm
        data={data}
        setData={setData}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
        reference={reference}
    >
        <Stack direction={{xs: 'column', md: 'row'}} sx={{width: '100%'}} spacing={1}>
            <CustomTextField
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='order_rx'
                label="Rendelt vevők száma"
                sx={{width: '100%'}}
            />

            <CustomTextField
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='order_tx'
                label="Rendelt ádók száma"
                sx={{width: '100%'}}
            />
        </Stack>
    </ErrorHandlingForm>
}

export default DeviceData